import {
  TextField,
  StandardTextFieldProps,
} from "@mui/material";
import React, { useState, ChangeEvent, useEffect } from "react";

interface CnpjFieldProps
  extends Omit<StandardTextFieldProps, "value" | "onChange"> {
  value?: string;
  onUpdate?: (cnpj: string) => void;
  customStyles?: React.CSSProperties;
  customClassName?: string;
}

const CnpjField: React.FC<CnpjFieldProps> = ({
  value = "",
  onUpdate,
  customStyles,
  customClassName,
  ...rest
}) => {
  const [cnpj, setCnpj] = useState<string>(value);

  useEffect(() => {
    setCnpj(value);
  }, [value]);

  const formatCnpj = (value: string): string => {
    return value
      .replace(/\D/g, "")
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3/$4")
      .replace(
        /^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d{1,2}).*/,
        "$1.$2.$3/$4-$5",
      );
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const value = event.target.value;
    const formattedValue = formatCnpj(value);
    setCnpj(formattedValue);
    onUpdate?.(formattedValue);
  };

  return (
    <div style={{ width: "100%" }}>
      <TextField
        {...rest}
        id="cnpj-input"
        value={cnpj}
        onChange={handleChange}
        variant="standard"
        fullWidth
        aria-label="CNPJ"
        data-testid="cnpj"
        style={{
          backgroundColor: "#FFF",
          ...customStyles,
        }}
        InputLabelProps={{
          shrink: true,
          style: {
            color: "#000",
            fontWeight: 400,
          },
        }}
        InputProps={{
          disableUnderline: true,
          className: customClassName,
          inputProps: {
            maxLength: 18,
          },
        }}
      />
    </div>
  );
};

export default CnpjField;
